<template>
    <ul class="layui-nav layui-nav-tree">
        <li class="layui-nav-item" :class="{'layui-nav-itemed' :  menu1.active}" v-for="menu1 in menus" v-bind:key="menu1.name" @click.stop="expand(menu1);$parent.menuFlexible()">
            <a  :class="{'root': !menu1.isLeaf , 'leaf' : menu1.isLeaf, 'leaf-active': currentMenu == menu1}"
                style="cursor: pointer"
                v-if="menu1.show"
                :lay-tips="menu1.title"
                lay-direction="2"
                 @click="menuClick(menu1)">
                <i class="layui-icon" :class="menu1.icon"></i>
                <cite v-text="menu1.title"></cite>
            </a>
        </li>
    </ul>
</template>

<script>
export default {
    name: 'LayuiMenu',
    props: {
        menus: {
            default: () => {
                return [];
            },
            type: Array
        },
        currentMenu: {
            default: () => {
                return {};
            },
            type: Object
        }
    },
    data: function(){
        return {
        }
     },
    mounted(){
        var activeMenu = null;
        for(var i = 0 ; i < this.menus.length; i++) {
            var first = this.menus[i];
            if(first.name == this.currentMenu.name) {
                first.active = true;
                activeMenu = first;
            }
        }
    },
    methods: {
       menuClick(menu) {
           this.$emit('menu-click', menu);
       },
       expand(menu){
           if(menu.children && menu.children.length > 0) {
               for(var i = 0 ; i < this.menus.length; i++) {
                    var first = this.menus[i];
                    if(first != menu ){
                        if(menu.parent == null) {
                            first.active = false;
                        } else {
                            if(first != menu.parent) {
                                if(menu.parent.parent != null) {
                                    if(first != menu.parent.parent) {
                                        first.active = false;
                                    }
                                } else {
                                    first.active = false;
                                }
                            }
                        }
                    }
                }
                var target = !menu.active
                menu.active = target;
           }
       }
    },
    watch:{

    }
}
</script>



// WEBPACK FOOTER //
// src/components/common/LayuiMenu.vue